import _ from 'underscore';


export async function handleResponse(response) {
  if (response.ok) return response.json();
  if (!response || response.status !== 'success'
    ) {
    // a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  throw new Error("Network response was not ok.");
}

export function handleError(error) {
  // TODO: Need to use front-end error logging service here...

  // eslint-disable-next-line no-console
  if (!_.isEmpty(error)) {
    console.error("API call failed. " + JSON.stringify(error));
    throw error;
  }
}

export const arrayToObject = (arr, keyField) => {
  // eslint-disable-next-line no-sequences
  return arr.reduce((obj, item) => (obj[item[keyField]] = item, obj) ,{});
};

export const objectTransform = (postedScheduleArray) => {
  // Part 1: replace dayTypes object with an array of objects
  for (let resource of postedScheduleArray) {
    if (resource.dayTypes && Array.isArray(resource.dayTypes)) {
        resource.dayTypes = arrayToObject(resource.dayTypes, 'rdtId');
      }
  }
  // Part 2: replace assignments object with an array of objects
  for (let resource of postedScheduleArray) {
      if (resource.dayTypes) {
        // eslint-disable-next-line no-unused-vars
        for (let [rdtId, dayType] of Object.entries(resource.dayTypes)) {
              if (dayType.tour && dayType.tour.assignments && Array.isArray(dayType.tour.assignments)) {
                  dayType.tour.assignments = arrayToObject(dayType.tour.assignments, 'jeId')
              }
          }
      }
  }
  return postedScheduleArray;
};

export const makeResourceFirst = (scheduleArray, resourceId) => {
  const first = resourceId.toString();
  scheduleArray.sort((a, b) => {
    // needs to be double equals as it is not guaranteed that the API returns a string
    return a.rId == first ? -1 : b.rId == first ? 1 : 0;
  });
  return scheduleArray;
};


export const storedProcParameters = {
  companyId: 1
};



// WEBPACK FOOTER //
// ./src/api/apiUtils.js